"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const ShareAmendConfirmationPopup_1 = __importDefault(require("@Components/Popups/ShareAmendConfirmationPopup"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const AmendSharesOptions = (props) => {
    const { onCancelAmendOption, onConfirmAmendOption, disabled } = props;
    const { userStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [displayAmendPopup, setDisplayAmendPopup] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onAmend = () => {
        onConfirmAmendOption();
        setDisplayAmendPopup(true);
    };
    const onRedirect = () => {
        setDisplayAmendPopup(false);
        navigate(navigation_1.default.rightholder.registrationHistory.pending(rightsholderStore.currentRightsholderId));
    };
    return (react_1.default.createElement("div", { className: 'amend-share-wrapper' },
        react_1.default.createElement(ModalPortal_1.default, { isOpen: displayAmendPopup },
            react_1.default.createElement(ShareAmendConfirmationPopup_1.default, { onClose: () => onRedirect() })),
        react_1.default.createElement("div", { className: 'amend-shares-options' },
            react_1.default.createElement("div", { className: 'top-section' },
                react_1.default.createElement("h6", null, "Confirm your amended shares"),
                react_1.default.createElement("p", null, "Click \"Confirm\" to confirm the new share percentage entered above, or click \"Cancel\" to return to the main Overclaims page.")),
            react_1.default.createElement("div", { className: 'buttons-area' },
                react_1.default.createElement(Button_1.Button, { type: 'primary', mainColor: true, onClick: onCancelAmendOption }, "Cancel"),
                react_1.default.createElement(Button_1.Button, { type: 'primary', mainColor: true, onClick: onAmend, disabled: disabled || userStore.isInternal }, "Confirm")))));
};
exports.default = AmendSharesOptions;
